<div class="tab-section">
  <div class="cpt-toolbar">
    <div class="cpt-toolbar-copy">
      <span class="cpt-eyebrow">ROTA DE RONDA</span>
      <div><strong>{{ totalRecords }}</strong> {{ totalRecords === 1 ? "checkpoint configurado" : "checkpoints configurados" }}</div>
      <small *ngIf="totalRecords > 0">{{ totalObrigatoriosNaPagina }} obrigatórios nesta página</small>
    </div>
    <button type="button" class="cpt-primary-btn" (click)="openNovoPonto()">
      <i class="ri-add-line"></i> Novo checkpoint
    </button>
  </div>

  <div *ngIf="loading" class="skeleton-wrap">
    <p-skeleton height="64px" styleClass="mb-2" *ngFor="let i of [1, 2, 3]"></p-skeleton>
  </div>

  <div class="cpt-empty-state" *ngIf="!loading && pontosCriticos.length === 0">
    <div class="cpt-empty-visual">
      <span class="cpt-empty-ring"></span>
      <span class="cpt-empty-icon"><i class="ri-map-pin-2-line"></i></span>
      <i class="cpt-route-dot dot-a"></i>
      <i class="cpt-route-dot dot-b"></i>
      <i class="cpt-route-dot dot-c"></i>
    </div>
    <p class="cpt-empty-title">Nenhum checkpoint configurado</p>
    <p class="cpt-empty-description">
      Adicione checkpoints a este posto para organizar e acompanhar as rondas.
    </p>
  </div>

  <ng-container *ngIf="!loading && pontosCriticos.length > 0">
    <div class="checkpoint-table">
      <div class="cpt-header">
        <span class="cpt-col-num">#</span>
        <span class="cpt-col-nome">Checkpoint</span>
        <span class="cpt-col-qr">QR Code</span>
        <span class="cpt-col-freq">Frequência</span>
        <span class="cpt-col-loc">Localização</span>
        <span class="cpt-col-obrig">Regra</span>
        <span class="cpt-col-acoes"></span>
      </div>

      <div
        class="cpt-row"
        *ngFor="let p of pontosCriticos; let i = index; trackBy: trackById"
        [class.is-optional]="p.obrigatorio === false"
      >
        <div class="cpt-col-num">
          <span class="cpt-num">{{ (page - 1) * pageSize + i + 1 }}</span>
        </div>
        <div class="cpt-col-nome">
          <span class="cpt-pin-icon"><i class="ri-map-pin-2-line"></i></span>
          <div class="cpt-name-copy">
            <span class="cpt-designacao">{{ p.designacao }}</span>
            <small>CPT-{{ ("000" + (p.id || i + 1)).slice(-3) }}</small>
          </div>
        </div>
        <div class="cpt-col-qr">
          <button
            type="button"
            class="cpt-qr-button"
            [class.has-qr]="hasActiveQr(p)"
            [pTooltip]="hasActiveQr(p) ? 'Ver QR Code ativo' : 'Gerar QR Code'"
            tooltipPosition="top"
            (click)="openQrCode(p)"
          >
            <i [class]="hasActiveQr(p) ? 'ri-qr-code-line' : 'ri-qr-scan-2-line'"></i>
            {{ hasActiveQr(p) ? "Ver QR" : "Gerar" }}
          </button>
        </div>
        <div class="cpt-col-freq">
          <span class="cpt-freq-pill">
            <i class="ri-loop-left-line"></i>
            {{ p.rondaPorTurno }} {{ p.rondaPorTurno === 1 ? "vez" : "vezes" }} / turno
          </span>
        </div>
        <div class="cpt-col-loc">
          <span class="cpt-loc-text" *ngIf="p.localizacao">
            <i class="ri-building-2-line"></i> {{ p.localizacao }}
          </span>
          <span class="cpt-empty-value" *ngIf="!p.localizacao">Não definida</span>
        </div>
        <div class="cpt-col-obrig">
          <span class="cpt-obrig-pill obrig-sim" *ngIf="p.obrigatorio !== false">
            <i class="ri-shield-check-line"></i> Obrigatório
          </span>
          <span class="cpt-obrig-pill obrig-nao" *ngIf="p.obrigatorio === false">
            <i class="ri-shield-line"></i> Opcional
          </span>
        </div>

        <div class="cpt-col-acoes">
          <p-menu #pontoMenu [model]="pontoMenuItems" [popup]="true" appendTo="body"></p-menu>
          <button
            type="button"
            class="cpt-action-btn"
            pTooltip="Opções"
            tooltipPosition="top"
            aria-label="Opções do checkpoint"
            (click)="buildPontoMenu(p, pontoMenu, $event)"
          >
            <i class="ri-more-2-fill"></i>
          </button>
        </div>
      </div>
    </div>

    <div class="cpt-pagination">
      <app-paginator-control
        [first]="(page - 1) * pageSize"
        [rows]="pageSize"
        [totalRecords]="totalRecords"
        [rowsPerPageOptions]="[5, 10, 20]"
        [showCurrentPageReport]="true"
        (pageChange)="onPageChange($event)"
      />
    </div>
  </ng-container>
</div>

<p-drawer
  [(visible)]="showDrawer"
  position="right"
  [modal]="true"
  [style]="{ width: 'min(680px, 96vw)' }"
  [baseZIndex]="10000"
  [closable]="true"
  styleClass="cpt-drawer"
  appendTo="body"
  (onHide)="closeDrawer()"
>
  <ng-template pTemplate="header">
    <div class="cpt-drawer-heading">
      <span class="cpt-drawer-heading-icon">
        <i [class]="editingPonto ? 'ri-edit-2-line' : 'ri-map-pin-add-line'"></i>
      </span>
      <div class="cpt-drawer-heading-copy">
        <span>{{ editingPonto ? "EDITAR CHECKPOINT" : "NOVO CHECKPOINT" }}</span>
        <h2>{{ editingPonto ? "Editar checkpoint" : "Novo checkpoint" }}</h2>
        <p>{{ editingPonto ? "Atualize a identificação e as regras." : "Adicione um ponto à rota de ronda." }}</p>
      </div>
    </div>
  </ng-template>

  <form
    id="checkpointForm"
    [formGroup]="pontoForm"
    class="cpt-dialog-form"
    (ngSubmit)="salvarPontoCritico()"
  >
    <div class="cpt-preview-card">
      <span class="cpt-preview-icon"><i class="ri-map-pin-2-fill"></i></span>
      <div class="cpt-preview-copy">
        <small>RESUMO DO CHECKPOINT</small>
        <strong>{{ pontoForm.get("designacao")?.value?.trim() || "Nome do checkpoint" }}</strong>
        <span><i class="ri-building-2-line"></i> {{ pontoForm.get("localizacao")?.value?.trim() || "Localização por definir" }}</span>
      </div>
      <div class="cpt-preview-meta">
        <span class="cpt-preview-frequency"><i class="ri-loop-left-line"></i> {{ periodicidadeLabel }}</span>
        <span class="cpt-preview-rule" [class.is-required]="pontoForm.get('obrigatorio')?.value">
          <i [class]="pontoForm.get('obrigatorio')?.value ? 'ri-shield-check-line' : 'ri-shield-line'"></i>
          {{ pontoForm.get("obrigatorio")?.value ? "Obrigatório" : "Opcional" }}
        </span>
      </div>
    </div>

    <section class="cpt-form-section">
      <div class="cpt-section-heading">
        <span>1</span>
        <div>
          <strong>Identificação</strong>
          <small>Dê um nome claro e indique onde o ponto está localizado.</small>
        </div>
      </div>

      <div class="cpt-identification-grid">
        <div class="cpt-form-field">
          <div class="cpt-label-row">
            <label for="checkpointName">Nome do checkpoint <span class="req">*</span></label>
            <small>{{ pontoForm.get("designacao")?.value?.length || 0 }}/100</small>
          </div>
          <div class="cpt-field-shell" [class.has-error]="pontoForm.get('designacao')?.invalid && pontoForm.get('designacao')?.touched">
            <i class="ri-map-pin-line"></i>
            <input id="checkpointName" pInputText formControlName="designacao" maxlength="100" autocomplete="off" placeholder="Ex.: Portão principal" />
          </div>
          <span class="cpt-error" *ngIf="pontoForm.get('designacao')?.invalid && pontoForm.get('designacao')?.touched">
            <i class="ri-error-warning-line"></i> Introduza um nome entre 2 e 100 caracteres.
          </span>
        </div>

        <div class="cpt-form-field">
          <div class="cpt-label-row">
            <label for="checkpointLocation">Localização no posto</label>
            <small>Opcional</small>
          </div>
          <div class="cpt-field-shell">
            <i class="ri-building-2-line"></i>
            <input id="checkpointLocation" pInputText formControlName="localizacao" maxlength="160" autocomplete="off" placeholder="Ex.: Piso 2 · Ala Norte" />
          </div>
          <small class="cpt-field-hint">Ajuda o efetivo a encontrar o ponto durante a ronda.</small>
        </div>
      </div>
    </section>

    <section class="cpt-form-section">
      <div class="cpt-section-heading">
        <span>2</span>
        <div>
          <strong>Frequência e regra</strong>
          <small>Defina o número de verificações esperado em cada turno.</small>
        </div>
      </div>

      <div class="cpt-preset-group">
        <div class="cpt-preset-copy">
          <strong>Frequência por turno</strong>
          <small>Escolha uma opção rápida ou informe outro valor.</small>
        </div>
        <div class="cpt-presets">
          <button type="button" *ngFor="let preset of rondaPresets" [class.active]="pontoForm.get('rondaPorTurno')?.value === preset" (click)="setRondaPorTurno(preset)">
            <strong>{{ preset }}x</strong>
            <small>por turno</small>
          </button>
        </div>
      </div>

      <div class="cpt-frequency-wrapper">
        <div class="cpt-custom-input-col">
          <label for="checkpointFrequency">Valor personalizado <span class="req">*</span></label>
          <div class="cpt-input-number-compact">
            <p-inputnumber 
              inputId="checkpointFrequency" 
              formControlName="rondaPorTurno" 
              [min]="1" 
              [max]="20" 
              [showButtons]="true" 
              [useGrouping]="false" 
              styleClass="cpt-input-number" 
            />
          </div>
          <small class="cpt-field-hint">Entre 1 e 20 verificações.</small>
        </div>

        <div class="cpt-period-card">
          <span><i class="ri-loop-left-line"></i></span>
          <div>
            <small>PERIODICIDADE DEFINIDA</small>
            <strong>{{ periodicidadeLabel }}</strong>
            <em>Esta regra será aplicada em todos os turnos.</em>
          </div>
        </div>
      </div>

      <button type="button" class="cpt-obrig-toggle" [class.is-obrigatorio]="pontoForm.get('obrigatorio')?.value" [attr.aria-pressed]="pontoForm.get('obrigatorio')?.value" (click)="pontoForm.get('obrigatorio')?.setValue(!pontoForm.get('obrigatorio')?.value)">
        <span class="cpt-obrig-icon"><i [class]="pontoForm.get('obrigatorio')?.value ? 'ri-shield-check-line' : 'ri-shield-line'"></i></span>
        <span class="cpt-obrig-body">
          <strong>Verificação obrigatória</strong>
          <small>{{ pontoForm.get("obrigatorio")?.value ? "A ronda só termina depois deste ponto ser verificado." : "O ponto pode ser ignorado sem bloquear a conclusão da ronda." }}</small>
        </span>
        <span class="cpt-obrig-switch" [class.on]="pontoForm.get('obrigatorio')?.value"><span class="cpt-obrig-thumb"></span></span>
      </button>
    </section>

    <div class="cpt-info-note">
      <i class="ri-information-line"></i>
      <span>O checkpoint fica disponível nas rondas deste posto imediatamente após guardar.</span>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <div class="cpt-drawer-footer">
      <span class="cpt-footer-note"><strong>*</strong> Campos obrigatórios</span>
      <div class="cpt-footer-actions">
        <button type="button" class="cpt-secondary-btn" (click)="closeDrawer()" [disabled]="loadingSavePonto">Cancelar</button>
        <button type="submit" form="checkpointForm" class="cpt-primary-btn" [disabled]="formInvalid">
          <i [class]="loadingSavePonto ? 'ri-loader-4-line cpt-spin' : 'ri-save-3-line'"></i>
          {{ loadingSavePonto ? "A guardar..." : editingPonto ? "Guardar alterações" : "Criar checkpoint" }}
        </button>
      </div>
    </div>
  </ng-template>
</p-drawer>

<p-dialog
  [(visible)]="showQrDrawer"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  [style]="{ width: 'min(540px, 94vw)' }"
  [baseZIndex]="10000"
  styleClass="cpt-qr-dialog"
  appendTo="body"
  (onHide)="closeQrDrawer()"
>
  <ng-template pTemplate="header">
    <div class="qr-drawer-heading">
      <span><i class="ri-qr-code-line"></i></span>
      <div>
        <small>IDENTIFICAÇÃO DO CHECKPOINT</small>
        <h2>QR Code</h2>
        <p>{{ qrPonto?.designacao }}</p>
      </div>
    </div>
  </ng-template>

  <div class="qr-drawer-body">
    <div class="qr-loading" *ngIf="loadingQr">
      <p-skeleton width="96px" height="18px"></p-skeleton>
      <p-skeleton width="280px" height="280px" borderRadius="16px"></p-skeleton>
      <p-skeleton width="100%" height="64px"></p-skeleton>
    </div>

    <div class="qr-empty" *ngIf="!loadingQr && !activeQrCode">
      <span class="qr-empty-icon"><i class="ri-qr-scan-2-line"></i></span>
      <h3>QR Code ainda não gerado</h3>
      <p>Gere a primeira versão para imprimir e afixar na zona deste checkpoint.</p>
      <button type="button" class="cpt-primary-btn" [disabled]="generatingQr" (click)="generateQrCode()">
        <i [class]="generatingQr ? 'ri-loader-4-line cpt-spin' : 'ri-qr-code-line'"></i>
        {{ generatingQr ? "A gerar..." : "Gerar QR Code" }}
      </button>
    </div>

    <ng-container *ngIf="!loadingQr && activeQrCode">
      <div class="qr-active-status">
        <span><i></i> Versão ativa</span>
        <small>Gerada em {{ activeQrCode.dataCriacao | date:'dd/MM/yyyy · HH:mm' }}</small>
      </div>

      <div class="qr-preview-card">
        <img *ngIf="qrPreviewUrl" [src]="qrPreviewUrl" [alt]="'QR Code de ' + (qrPonto?.designacao || 'checkpoint')" />
        <div class="qr-preview-loading" *ngIf="!qrPreviewUrl && !qrPreviewUnavailable">
          <i class="ri-loader-4-line cpt-spin"></i><span>A carregar imagem válida...</span>
        </div>
        <div class="qr-preview-error" *ngIf="qrPreviewUnavailable">
          <i class="ri-image-off-line"></i>
          <strong>Imagem indisponível</strong>
          <span>Volte a abrir o painel ou regenere o QR Code.</span>
        </div>
      </div>

      <div class="qr-details">
        <div>
          <small>CHECKPOINT</small>
          <strong>{{ qrPonto?.designacao }}</strong>
          <span>{{ qrPonto?.localizacao || "Localização não definida" }}</span>
        </div>
        <div>
          <small>VALIDADE</small>
          <strong>{{ activeQrCode.dataExpiracao ? (activeQrCode.dataExpiracao | date:'dd/MM/yyyy') : "Sem expiração" }}</strong>
          <span>ID {{ activeQrCode.publicId }}</span>
        </div>
      </div>

      <div class="qr-print-note">
        <i class="ri-printer-line"></i>
        <span>Baixe o PNG, imprima com bom contraste e afixe-o numa superfície plana e acessível no ponto.</span>
      </div>
    </ng-container>
  </div>

  <ng-template pTemplate="footer">
    <div class="qr-drawer-footer">
      <button type="button" class="cpt-secondary-btn" (click)="closeQrDrawer()">Fechar</button>
      <div *ngIf="activeQrCode" class="qr-footer-actions">
        <button type="button" class="cpt-primary-btn" [disabled]="!qrPreviewUrl" (click)="printQrCode()">
          <i class="ri-printer-line"></i> Imprimir
        </button>
        <button type="button" class="cpt-secondary-btn" [disabled]="generatingQr" (click)="generateQrCode()">
          <i [class]="generatingQr ? 'ri-loader-4-line cpt-spin' : 'ri-refresh-line'"></i>
          Regenerar
        </button>
      </div>
    </div>
  </ng-template>
</p-dialog>